import React from 'react';
import { ColumnHeader, Loader } from '@deque/cauldron-react';
import { useTranslation } from 'react-i18next';
import { type ErrorOrNull } from '../../../typings/utils';
import styles from './CommonConnected.css';

export interface CommonConnectedProps {
  connectionsLoading: boolean;
  integrationsLoading: boolean;
  connectionsError: ErrorOrNull;
  integrationsError: Error | null;
  connectionDenied: boolean;
}

function CommonConnected({
  connectionsLoading,
  integrationsLoading,
  connectionsError,
  integrationsError,
  connectionDenied
}: CommonConnectedProps) {
  const { t } = useTranslation();

  let content: JSX.Element;
  if (connectionsLoading || integrationsLoading) {
    content = <Loader label={t('Processing...')} />;
  } else if (connectionsError || integrationsError) {
    content = (
      <div className={styles.content}>
        <h3>{t('Error registering new connection')}</h3>
        <p>{t('Close this window to continue')}</p>
      </div>
    );
  } else if (connectionDenied) {
    content = (
      <div className={styles.content}>
        <h3>{t('Connection to Jira was denied')}</h3>
        <p>{t('Close this window to continue')}</p>
      </div>
    );
  } else {
    content = (
      <div className={styles.content}>
        <h3>{t('Connection to Jira is successful')}</h3>
        <p>{t('Close this window to continue')}</p>
      </div>
    );
  }

  return (
    <>
      <ColumnHeader>
        <h2>{t('Jira Connection')}</h2>
      </ColumnHeader>
      {content}
    </>
  );
}

export default CommonConnected;
